import Radio from "components/radio";
import RadioGroup from "components/radio-group";
import PropTypes from "prop-types";
import {
  isLoadCompositionFlowSupplierSide,
  isPurchaseOrderFlow,
  usesReturnableAssets,
  usesTransferOrder,
} from "utils/validations-general-settings";
import { supplierOrigin, supplierValues } from "../../supplier-utils";

function RadioGroupMaterialForm({ handleChange, label, materialOrigin }) {
  return (
    <RadioGroup directionItems="row" label={label} name="OrigemMaterial">
      <Radio
        checked={supplierOrigin.IsPurchase(materialOrigin)}
        text={supplierOrigin.getName(supplierValues.COMPRA_DE_INSUMOS)}
        value={supplierValues.COMPRA_DE_INSUMOS}
        onChange={handleChange}
      />
      {usesTransferOrder() ? (
        <Radio
          checked={supplierOrigin.IsTransfer(materialOrigin)}
          text={supplierOrigin.getName(supplierValues.TRANSFERENCIA)}
          value={supplierValues.TRANSFERENCIA}
          onChange={handleChange}
        />
      ) : (
        <div />
      )}

      {usesReturnableAssets() && isLoadCompositionFlowSupplierSide() && isPurchaseOrderFlow() ? (
        <Radio
          checked={supplierOrigin.IsAtgPurchase(materialOrigin)}
          text={supplierOrigin.getName(supplierValues.COMPRA_ATG)}
          value={supplierValues.COMPRA_ATG}
          onChange={handleChange}
        />
      ) : (
        <div />
      )}
      <Radio
        checked={supplierOrigin.IsConsigneeStock(materialOrigin)}
        text={supplierOrigin.getName(supplierValues.CONSIGNEE_STOCK)}
        value={supplierValues.CONSIGNEE_STOCK}
        onChange={handleChange}
      />
    </RadioGroup>
  );
}

RadioGroupMaterialForm.propTypes = {
  handleChange: PropTypes.any.isRequired,
  label: PropTypes.any.isRequired,
  materialOrigin: PropTypes.any.isRequired,
};

export default RadioGroupMaterialForm;
